import { hardRedirectTo } from '../../../../../../../utils';
import Button from '../../../../../../generic/Button/Button';
import { icons } from '../../../../../../generic/Icon';

export const AuthGoogleStepBody = () => (
  <p>To setup Google Workspace, sign into Google with an email that has the domain you’d like to configure:</p>
);

export const AuthGoogleStepButtons = () => (
  <Button icon={icons.google} onClick={() => hardRedirectTo('/account/google/init_sso')}>
    Sign in with Google
  </Button>
);
